require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-yarrabend-stand-prize.json") })
        }
      }, "path---news-yarrabend-stand-prize");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-yarrabend-stand-prize!./.cache/json/news-yarrabend-stand-prize.json
// module id = 873
// module chunks = 231608221292675